// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy_privacy__3ghwl","privacy__text":"privacy_privacy__text__E1BH_"};